import * as React from "react";

export function Accordion({ type = "single", collapsible = false, className = "", children }) {
  // Support both single and multiple open items
  const [openIdx, setOpenIdx] = React.useState(type === "multiple" ? [] : null);

  const handleToggle = (idx) => {
    if (type === "multiple") {
      setOpenIdx((prev) => {
        if (prev.includes(idx)) {
          return collapsible ? prev.filter((i) => i !== idx) : prev;
        } else {
          return [...prev, idx];
        }
      });
    } else {
      if (collapsible && openIdx === idx) {
        setOpenIdx(null);
      } else {
        setOpenIdx(idx);
      }
    }
  };

  // Children must be AccordionItem
  const items = React.Children.map(children, (child, idx) => {
    if (!React.isValidElement(child)) return null;
    const isOpen = type === "multiple" ? openIdx.includes(idx) : openIdx === idx;
    return React.cloneElement(child, {
      open: isOpen,
      onToggle: () => handleToggle(idx),
      idx,
    });
  });
  return <div className={`shadcn-accordion ${className}`}>{items}</div>;
}

export function AccordionItem({ value, open, onToggle, children, idx }) {
  // Children: AccordionTrigger, AccordionContent
  let trigger = null, content = null;
  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type.displayName === "AccordionTrigger") trigger = child;
    if (child.type.displayName === "AccordionContent") content = child;
  });
  return (
    <div className={`shadcn-accordion-item border-b ${open ? 'active-open' : ''}`}>
      {trigger && React.cloneElement(trigger, { open, onToggle })}
      {content && React.cloneElement(content, { open })}
    </div>
  );
}

export function AccordionTrigger({ children, open, onToggle }) {
  return (
    <button
      type="button"
      className={`shadcn-accordion-trigger rounded-t-md w-full flex justify-between items-center py-4 font-medium text-left focus:outline-none px-5 ${open ? "text-theme-primary bg-[#c4cffa]" : "text-theme-secondary"}`}
      aria-expanded={open}
      onClick={onToggle}
      style={{ transition: 'background 0.2s' }}
    >
      <span>{children}</span>
      <svg
        className={`ml-2 h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : "rotate-0"}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M6 9l6 6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
AccordionTrigger.displayName = "AccordionTrigger";

export function AccordionContent({ children, open }) {
  return (
    <div
      className={`shadcn-accordion-content transition-all duration-200 ease-in-out overflow-hidden ${open ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
      style={{}}
    >
      <div className="py-3 px-5 text-left bg-blue-50">{children}</div>
    </div>
  );
}
AccordionContent.displayName = "AccordionContent";
